var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3641 16.3639L17.0713 17.071C15.1218 19.0205 12.561 19.9952 10.0002 19.9952C7.43939 19.9952 4.8786 19.0205 2.92908 17.071C-0.969849 13.172 -0.969849 6.82788 2.92908 2.92883C6.82812 -0.970093 13.1722 -0.970093 17.0713 2.92883L16.3641 3.63599C12.8551 0.126954 7.14526 0.126954 3.63623 3.63599C0.127138 7.14508 0.127138 12.8548 3.63623 16.3639C7.14533 19.873 12.855 19.873 16.3641 16.3639ZM15.8538 13.8535L19.7073 9.99994L15.8538 6.14636L15.1466 6.85352L17.7931 9.49994H11.0002V10.4999H17.7931L15.1466 13.1464L15.8538 13.8535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.87e70936c0e3fcb8d1eec0053b5402b0.svg";
export { ForwardRef as ReactComponent };